import React from 'react';

import Lorem from './components/Lorem'
import Meta from './components/Meta'
import HeadingText from './components/HeadingText'
import Icon from './components/Icon'
import Buttons from './components/Buttons'

import styles from './styles/utils.module.css'

export default function App() {
  return ( <>
    <Meta></Meta>
    <div className={styles.main}>
      <Icon></Icon>
      <HeadingText></HeadingText>
      <Buttons></Buttons>
      <br />
      <Lorem></Lorem>
    </div>
  </>);
}


